/* iceberg UI */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Avatar, Box } from '@mui/material';
import { ExtensionInstalledBadge } from 'application/Shared/Components/Avatars/ExtensionInstalledBadge';

/*  Shared  */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';
import { BROWSER_BASENAMES, FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

const AvatarIcon = ({ baseName, size = FontSizes[1] }) => {
    const {
        BRAVE,
        CHROME,
        CHROME_ALT,
        EDGE,
        EDGE_CHROMIUM,
        FIREFOX,
        OPERA,
        SAFARI
    } = BROWSER_BASENAMES;

    switch (baseName) {
        case BRAVE:
            return <IconWithVariant variant="avatar" src="Brave" size={size} />;
        case CHROME:
        case CHROME_ALT:
            return (
                <IconWithVariant variant="avatar" src="Chrome" size={size} />
            );
        case EDGE:
        case EDGE_CHROMIUM:
            return (
                <IconWithVariant
                    data-testid="edgeIcon"
                    variant="avatar"
                    src="Edge"
                    size={size}
                />
            );
        case FIREFOX:
            return (
                <IconWithVariant variant="avatar" src="Firefox" size={size} />
            );
        case OPERA:
            return <IconWithVariant variant="avatar" src="Opera" size={size} />;
        case SAFARI:
            return (
                <IconWithVariant variant="avatar" src="Safari" size={size} />
            );
        default:
            return <IconWithVariant variant="avatar" src="Web" size={size} />;
    }
};

export const Browser = ({
    browser,
    iconOnly,
    avatarGroup,
    noTooltip,
    containerStyles = {}
}) => {
    const { application, extensionInstalled, userAgent } = browser;
    if (!application) {
        return null;
    }

    const { baseName, name } = application;
    if (!baseName || !name) {
        return null;
    }
    if (avatarGroup) {
        return (
            <ExtensionInstalledBadge
                avatarGroup={avatarGroup}
                extensionInstalled={extensionInstalled}
            >
                <Avatar
                    data-testid="browserBubbleAvatar"
                    sx={{
                        backgroundColor: 'background.avatar',
                        marginRight: '-4px'
                    }}
                >
                    <AvatarIcon baseName={baseName} />
                </Avatar>
            </ExtensionInstalledBadge>
        );
    }
    if (iconOnly) {
        return (
            <DarkTooltip arrow title={name}>
                <Avatar sx={{ backgroundColor: 'background.avatar' }}>
                    <AvatarIcon baseName={baseName} />
                </Avatar>
            </DarkTooltip>
        );
    }

    let tooltip = '';
    if (extensionInstalled) {
        tooltip = noTooltip ? '' : userAgent;
    }

    return (
        <Box
            display="flex"
            alignItems="center"
            marginBottom="16px"
            {...containerStyles}
        >
            <DarkTooltip
                arrow
                title={tooltip}
                placement="left"
                data-testid="browserTooltip"
            >
                <Box>
                    <ExtensionInstalledBadge
                        avatarGroup={avatarGroup}
                        extensionInstalled={extensionInstalled}
                    >
                        <Avatar
                            data-testid="browserAvatarWrapper"
                            sx={{
                                backgroundColor: 'background.avatar',
                                float: 'left',
                                height: '35px',
                                marginRight: '8px',
                                width: '35px'
                            }}
                        >
                            <AvatarIcon
                                baseName={baseName}
                                size={FontSizes[2]}
                            />
                        </Avatar>
                    </ExtensionInstalledBadge>
                </Box>
            </DarkTooltip>
            <small
                data-testid="browsersObjectName"
                style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}
            >
                {name}
            </small>
        </Box>
    );
};
